import {WebStorage} from 'proxy-storage';
import warn from '../../js/utils/warnings/warn';
import randomValue from '../../js/utils/randomValue';
import dataLayerBase from '../../js/utils/dom/dataLayer';
import dataLayer from './dataLayerDisplayByg';

const DISABLE = 'YES';
const cookieStore = new WebStorage('cookieStorage');
let cookieExpire,
  cookieName,
  cookieDomain;
const rootHTML = document.documentElement;

/**
 * export this function globally to disable the exit messaging
 */
function disableExitMessaging() {
  const ms = cookieExpire * 24 * 60 * 60 * 1000;
  const date = new Date();

  date.setTime(date.getTime() + ms);
  cookieStore.setItem(cookieName, DISABLE, {
    domain: cookieDomain,
    expires: {date},
  });
}

window.disableExitMessaging = disableExitMessaging;

/**
 * @param {Object} config config
 * @returns {undefined}
 */
function beforeYouGo({
  callback,
  startIn = 0,
  maxTimeInactive = 1000,
  aggressive = false,
  experienceName,
  device,
  modalType = 'byg',
  displayBYGPercentage = 0.1,
  enableMouseExitIntent = false,
}) {
  let intervalRef;
  let countTime = maxTimeInactive;
  const timeToCheck = 100;
  const isDisabled = cookieStore.getItem(cookieName) === DISABLE && !aggressive;

  if (isDisabled) {
    return;
  }

  const isEligbleToDispatchBYG = randomValue() > displayBYGPercentage;
  const eligibleEventName = `eligible-${modalType}-${device}-${experienceName}`;

  if (isEligbleToDispatchBYG) {
    dataLayerBase(eligibleEventName);
  } else {
    dataLayerBase(`${eligibleEventName}-control`);
  }

  /**
   * restart count variable
   */
  function restartCountVariable() {
    countTime = maxTimeInactive;
  }

  /**
   * @param {String} method method to event listener (addEventListener | removeEventListener)
   */
  function eventListener(method) {
    if (enableMouseExitIntent && !isDisabled) {
      rootHTML[method]('mouseleave', checkExitIntentOnTop);
    }

    ['wheel', 'mousemove', 'click', 'keypress', 'contextmenu', 'touchmove']
      .forEach(event => rootHTML[method](event, restartCountVariable));
  }

  /**
   * Dispatch BYG only if the users mouseout on top of the document
   *
   * @param {Event} event Original mouseout event object
   */
  function checkExitIntentOnTop(event) {
    event = event || window.event;
    const from = event.currentTarget;
    if (from.nodeName === 'HTML' && event.clientY <= 20) {
      dispatchBYG();
    }
  }

  /**
   * dispatch before you go
   */
  function dispatchBYG() {
    if (isDisabled) {
      return;
    }

    eventListener('removeEventListener');
    disableExitMessaging();


    clearInterval(intervalRef);

    try {
      if (isEligbleToDispatchBYG) {
        callback();
      } else {
        dataLayer(`control-${experienceName}`, modalType);
      }
    } catch (e) {
      warn(e);
    }
  }

  /**
   * check time to dispatch byg function
   */
  function checkAction() {
    if (countTime > 0) {
      countTime -= timeToCheck;
    } else {
      dispatchBYG();
    }
  }

  /**
   * init to check user actions
   */
  function setIntentExit() {
    eventListener('addEventListener');
    intervalRef = setInterval(checkAction, timeToCheck);
  }

  setTimeout(setIntentExit, startIn);
}

/**
 * @param {Number} _cookieExpire cookie expire
 * @param {*} _cookieName cookie name
 * @param {*} _cookieDomain cookie domain
 * @return {Function}
 */
function init(_cookieExpire = 1, _cookieName = 'viewedHCModal', _cookieDomain) {
  cookieExpire = _cookieExpire;
  cookieName = _cookieName;
  cookieDomain = _cookieDomain;

  return beforeYouGo;
}

export default init;
